// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"d70bb1b2","732":"774d6aff","977":"0c480f8c"}[chunkId] + ".chunk.js";
};